import { ReactComponent } from "./memo-pick-up-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const MemoPickUpLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default MemoPickUpLineIcon;
